import { computed } from 'vue';

export function useWhatsAppBadge() {
  return computed(() => null);
}

const channelTypeColorMap = {
  'Channel::Whatsapp': 'text-n-teal-9',
  'Channel::DinastiaWhatsapp': 'text-n-teal-9',
  'Channel::FacebookPage': 'text-n-blue-9',
  'Channel::Instagram': 'text-n-ruby-9',
  'Channel::Email': 'text-n-blue-11',
  'Channel::Telegram': 'text-n-blue-9',
  'Channel::Api': 'text-n-violet-9',
  'Channel::WebWidget': 'text-n-amber-9',
  'Channel::Sms': 'text-n-teal-11',
  'Channel::TwilioSms': 'text-n-teal-11',
  'Channel::Line': 'text-n-teal-9',
  'Channel::TwitterProfile': 'text-n-slate-9',
  'Channel::Tiktok': 'text-n-slate-9',
  'Channel::Voice': 'text-n-amber-11',
};

export function getChannelColor(channelType, provider) {
  // Official WhatsApp API: black in light mode, white in dark mode
  if (channelType === 'Channel::Whatsapp' && provider === 'whatsapp_cloud') {
    return 'text-n-slate-12';
  }
  return channelTypeColorMap[channelType] || 'text-n-slate-9';
}

export function useChannelColor(inbox) {
  return computed(() => {
    const inboxDetails = inbox.value || inbox;
    return getChannelColor(inboxDetails.channel_type, inboxDetails.provider);
  });
}

export function useChannelIcon(inbox) {
  const channelTypeIconMap = {
    'Channel::Api': 'i-woot-api',
    'Channel::Email': 'i-woot-mail',
    'Channel::FacebookPage': 'i-woot-messenger',
    'Channel::Line': 'i-woot-line',
    'Channel::Sms': 'i-woot-sms',
    'Channel::Telegram': 'i-woot-telegram',
    'Channel::TwilioSms': 'i-woot-sms',
    'Channel::TwitterProfile': 'i-ri-twitter-x-fill',
    'Channel::WebWidget': 'i-woot-website',
    'Channel::Whatsapp': 'i-woot-whatsapp',
    'Channel::Instagram': 'i-woot-instagram',
    'Channel::Tiktok': 'i-woot-tiktok',
    'Channel::Voice': 'i-ri-phone-fill',
    'Channel::DinastiaWhatsapp': 'i-woot-whatsapp',
  };

  const providerIconMap = {
    microsoft: 'i-woot-outlook',
    google: 'i-woot-gmail',
  };

  const channelIcon = computed(() => {
    const inboxDetails = inbox.value || inbox;
    const type = inboxDetails.channel_type;
    let icon = channelTypeIconMap[type];

    if (type === 'Channel::Email' && inboxDetails.provider) {
      if (Object.keys(providerIconMap).includes(inboxDetails.provider)) {
        icon = providerIconMap[inboxDetails.provider];
      }
    }

    // Special case for Twilio whatsapp
    if (type === 'Channel::TwilioSms' && inboxDetails.medium === 'whatsapp') {
      icon = 'i-woot-whatsapp';
    }

    return icon ?? 'i-ri-global-fill';
  });

  return channelIcon;
}
